import { render, staticRenderFns } from "./custom-map.vue?vue&type=template&id=2b815631&scoped=true"
import script from "./custom-map.vue?vue&type=script&lang=js"
export * from "./custom-map.vue?vue&type=script&lang=js"
import style0 from "./custom-map.vue?vue&type=style&index=0&id=2b815631&prod&scoped=true&lang=css"
import style1 from "./custom-map.vue?vue&type=style&index=1&id=2b815631&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b815631",
  null
  
)

export default component.exports